var render, staticRenderFns
import script from "./materialMixin.vue?vue&type=script&lang=js"
export * from "./materialMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('634eaa50')) {
      api.createRecord('634eaa50', component.options)
    } else {
      api.reload('634eaa50', component.options)
    }
    
  }
}
component.options.__file = "src/components/consultant/material/mixin/materialMixin.vue"
export default component.exports